import { Inject, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

@Injectable({
  providedIn: 'root',
})
export class PaginatorItaService extends MatPaginatorIntl {
  itemsPerPageLabel = '';
  nextPageLabel = '';
  previousPageLabel = '';
  firstPageLabel = '';
  lastPageLabel = '';

  constructor(@Inject(I18NEXT_SERVICE) private translateService: ITranslationService) {
    super();
    this.itemsPerPageLabel = this.translateService.t('paginator.content');
  }
  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return '0 di ' + length;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return startIndex + 1 + ' - ' + endIndex + ' di ' + length;
  };
}
